import React from 'react'
import Google from './google'
import Facebook from './facebook'

interface SocialProps {
  new: boolean
}

// DRI-253: every business uses the Facebook Builder panel. One on a person (no system user of ours could
// reach both its assets) shows that person in the panel instead of a separate Authorizer-only screen.
const Social = (props: SocialProps) => (
  <div>
    <Facebook new={props.new} />
    <Google />
  </div>
)

export default Social
